import { SharedModule } from '@app/shared/shared.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

// Roteamento
import { ConfiguracoesRoutingModule } from './configuracoes.routing';

// Componentes
import { CidadeListaComponent } from '@app/pages/configuracoes/cidade/cidade-lista/cidade-lista.component';
import { CidadeFormComponent } from '@app/pages/configuracoes/cidade/cidade-form/cidade-form.component';
import { AtoProcessualListaComponent } from '@app/pages/configuracoes/ato-processual/ato-processual-lista/ato-processual-lista.component';
import { AtoProcessualFormComponent } from '@app/pages/configuracoes/ato-processual/ato-processual-form/ato-processual-form.component';
import { BancoListaComponent } from '@app/pages/configuracoes/banco/banco-lista/banco-lista.component';
import { BancoFormComponent } from '@app/pages/configuracoes/banco/banco-form/banco-form.component';
import { ContaListaComponent } from '@app/pages/configuracoes/conta/conta-lista/conta-lista.component';
import { ContaFormComponent } from '@app/pages/configuracoes/conta/conta-form/conta-form.component';
import { DocumentoListaComponent } from '@app/pages/configuracoes/documento/documento-lista/documento-lista.component';
import { DocumentoFormComponent } from '@app/pages/configuracoes/documento/documento-form/documento-form.component';
import { EstadoDoProcessoListaComponent } from '@app/pages/configuracoes/estado-do-processo/estado-do-processo-lista/estado-do-processo-lista.component';
import { EstadoDoProcessoFormComponent } from '@app/pages/configuracoes/estado-do-processo/estado-do-processo-form/estado-do-processo-form.component';
import { NaturezaDeAcaoListaComponent } from '@app/pages/configuracoes/natureza-de-acao/natureza-de-acao-lista/natureza-de-acao-lista.component';
import { NaturezaDeAcaoFormComponent } from '@app/pages/configuracoes/natureza-de-acao/natureza-de-acao-form/natureza-de-acao-form.component';
import { OrgaoDoJudiciarioListaComponent } from '@app/pages/configuracoes/orgao-do-judiciario/orgao-do-judiciario-lista/orgao-do-judiciario-lista.component';
import { OrgaoDoJudiciarioFormComponent } from '@app/pages/configuracoes/orgao-do-judiciario/orgao-do-judiciario-form/orgao-do-judiciario-form.component';
import { PedidoListaComponent } from '@app/pages/configuracoes/pedido/pedido-lista/pedido-lista.component';
import { PedidoFormComponent } from '@app/pages/configuracoes/pedido/pedido-form/pedido-form.component';
import { PosicaoDoClienteListaComponent } from '@app/pages/configuracoes/posicao-do-cliente/posicao-do-cliente-lista/posicao-do-cliente-lista.component';
import { PosicaoDoClienteFormComponent } from '@app/pages/configuracoes/posicao-do-cliente/posicao-do-cliente-form/posicao-do-cliente-form.component';
import { RitoListaComponent } from '@app/pages/configuracoes/rito/rito-lista/rito-lista.component';
import { RitoFormComponent } from '@app/pages/configuracoes/rito/rito-form/rito-form.component';
import { TipoDeAcaoListaComponent } from '@app/pages/configuracoes/tipo-de-acao/tipo-de-acao-lista/tipo-de-acao-lista.component';
import { TipoDeAcaoFormComponent } from '@app/pages/configuracoes/tipo-de-acao/tipo-de-acao-form/tipo-de-acao-form.component';
import { TipoDeJulgamentoListaComponent } from '@app/pages/configuracoes/tipo-de-julgamento/tipo-de-julgamento-lista/tipo-de-julgamento-lista.component';
import { TipoDeJulgamentoFormComponent } from '@app/pages/configuracoes/tipo-de-julgamento/tipo-de-julgamento-form/tipo-de-julgamento-form.component';
import { UnidadeListaComponent } from '@app/pages/configuracoes/unidade/unidade-lista/unidade-lista.component';
import { UnidadeFormComponent } from '@app/pages/configuracoes/unidade/unidade-form/unidade-form.component';
import { UsuarioTipoListaComponent } from '@app/pages/configuracoes/usuario-tipo/usuario-tipo-lista/usuario-tipo-lista.component';
import { UsuarioTipoFormComponent } from '@app/pages/configuracoes/usuario-tipo/usuario-tipo-form/usuario-tipo-form.component';
import { MeAviseTipoListaComponent } from '@app/pages/configuracoes/me-avise-tipo/me-avise-tipo-lista/me-avise-tipo-lista.component';
import { MeAviseTipoFormComponent } from '@app/pages/configuracoes/me-avise-tipo/me-avise-tipo-form/me-avise-tipo-form.component';
import { EntrevistaListaComponent } from '@app/pages/configuracoes/entrevista/entrevista-lista/entrevista-lista.component';
import { EntrevistaFormComponent } from '@app/pages/configuracoes/entrevista/entrevista-form/entrevista-form.component';
import { DemonstrativoResultadoComponent } from '@app/pages/configuracoes/demonstrativo-de-resultado/demonstrativo-de-resultado.component';
import { FormaDePagamentoListaComponent } from '@app/pages/configuracoes/forma-de-pagamento/forma-de-pagamento-lista/forma-de-pagamento-lista.component';
import { FormaDePagamentoFormComponent } from '@app/pages/configuracoes/forma-de-pagamento/forma-de-pagamento-form/forma-de-pagamento-form.component';
import { SubcategoriasFormComponent } from './subcategorias/subcategorias-form/subcategorias-form.component';
import { SubcategoriasListComponent } from './subcategorias/subcategorias-list/subcategorias-list.component';
import { InstanciaFormComponent } from './instancia/instancia-form/instancia-form.component';
import { InstanciaListaComponent } from './instancia/instancia-lista/instancia-lista.component';
import { AreaListaComponent } from '@app/pages/configuracoes/area/area-lista/area-lista.component';
import { AreaFormComponent } from '@app/pages/configuracoes/area/area-form/area-form.component';
// Services
import { AtoProcessualService } from '@app/services/ato-processual.service';
import { EstadoDoProcessoService } from '@app/services/estado-do-processo.service';
import { EstadoMovDoProcessoService } from '@app/services/estado-mov-do-processo.service';
import { FinanceiroProcessoService } from '@app/services/financeiro-processo.service';
import { AreaService } from '@app/services/area.service';

// Módulos terceiros
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TreeModule } from '@circlon/angular-tree-component';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { MetaListaComponent } from './metas/meta-lista/meta-lista.component';
import { MetaFormComponent } from './metas/meta-form/meta-form.component';
import { MetaService } from '@app/services/meta.service';


@NgModule({
  declarations: [
    CidadeListaComponent,
    CidadeFormComponent,
    AtoProcessualListaComponent,
    AtoProcessualFormComponent,
    BancoListaComponent,
    BancoFormComponent,
    ContaListaComponent,
    ContaFormComponent,
    DocumentoListaComponent,
    DocumentoFormComponent,
    EstadoDoProcessoListaComponent,
    EstadoDoProcessoFormComponent,
    NaturezaDeAcaoListaComponent,
    NaturezaDeAcaoFormComponent,
    OrgaoDoJudiciarioListaComponent,
    OrgaoDoJudiciarioFormComponent,
    PedidoListaComponent,
    PedidoFormComponent,
    PosicaoDoClienteListaComponent,
    PosicaoDoClienteFormComponent,
    RitoListaComponent,
    RitoFormComponent,
    TipoDeAcaoListaComponent,
    InstanciaFormComponent,
    InstanciaListaComponent,
    TipoDeAcaoFormComponent,
    TipoDeJulgamentoListaComponent,
    TipoDeJulgamentoFormComponent,
    UnidadeListaComponent,
    UnidadeFormComponent,
    UsuarioTipoListaComponent,
    UsuarioTipoFormComponent,
    MeAviseTipoListaComponent,
    MeAviseTipoFormComponent,
    EntrevistaListaComponent,
    EntrevistaFormComponent,
    DemonstrativoResultadoComponent,
    FormaDePagamentoListaComponent,
    FormaDePagamentoFormComponent,
    SubcategoriasListComponent,
    SubcategoriasFormComponent,
    MetaListaComponent,
    MetaFormComponent,
    AreaListaComponent,
    AreaFormComponent
  ],
  imports: [
    ConfiguracoesRoutingModule,
    SharedModule,
    TreeModule,
    DragDropModule,
    ReactiveFormsModule,
    TextMaskModule,
  ],
  providers: [
    AtoProcessualService,
    EstadoDoProcessoService,
    EstadoMovDoProcessoService,
    FinanceiroProcessoService,
    MetaService,
    AreaService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ConfiguracoesModule { }
